import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";

import { NewsFeedItemPostEvent, NewsFeedItemRecommendationEvent } from "../types";

// eslint-disable-next-line complexity
export function getNewsFeedContentText(params: {
  event: NewsFeedItemPostEvent | NewsFeedItemRecommendationEvent;
  currentWorkerName: string;
  workerName?: string;
  referredWorkerName?: string;
  recommendedWorkerName?: string;
  workplaceName?: string;
  recommendedWorkplaceName?: string;
  shiftQualificationDisplayLabel?: string;
}) {
  const {
    event,
    currentWorkerName,
    workerName,
    referredWorkerName = "them",
    recommendedWorkerName,
    workplaceName,
    recommendedWorkplaceName,
    shiftQualificationDisplayLabel = "",
  } = params;

  const viewingOwnNewsEvent = currentWorkerName === workerName;

  switch (event) {
    case NewsFeedItemPostEvent.WORKER_RECEIVED_INSTANT_PAY: {
      return `${viewingOwnNewsEvent ? "You" : workerName ?? "Your friend"} got paid instantly for ${
        viewingOwnNewsEvent ? "your" : "their"
      } shift at ${workplaceName ?? "a workplace"} 💰`;
    }

    case NewsFeedItemPostEvent.WORKER_REVIEWED_WORKPLACE: {
      return `${viewingOwnNewsEvent ? "You" : workerName ?? "Your friend"} reviewed ${
        workplaceName ?? "a workplace"
      }.`;
    }

    case NewsFeedItemPostEvent.WORKER_BOOKED_SHIFT_AT_WORKPLACE_WITH_OPENINGS: {
      return `${
        viewingOwnNewsEvent ? "You" : workerName ?? "Your friend"
      } booked a ${shiftQualificationDisplayLabel} shift at ${
        workplaceName ?? "a workplace"
      } and it has more openings.`;
    }

    case NewsFeedItemPostEvent.REFERRED_NEW_WORKER_JOINED: {
      return `${referredWorkerName} joined Clipboard after ${
        viewingOwnNewsEvent ? "you" : workerName ?? "your friend"
      } referred them!`;
    }

    case NewsFeedItemRecommendationEvent.FRIEND_RECOMMENDATION: {
      return `Do you know ${recommendedWorkerName}? You worked together at ${
        workplaceName ?? "a workplace"
      }.`;
    }

    case NewsFeedItemRecommendationEvent.WORKPLACE_RECOMMENDATION: {
      return `Check out ${recommendedWorkplaceName ?? "this workplace"} that is popular with ${
        workerName ?? "your friend"
      }!`;
    }

    default: {
      logError(APP_V2_APP_EVENTS.UNSUPPORTED_NEWS_FEED_EVENT, {
        error: "Unsupported news feed event",
        metadata: { event },
      });
      return "";
    }
  }
}
